// File: src/components_1/SprintTrendGraph.js
import React from "react";
import { 
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend 
} from "recharts";

const SprintTrendGraph = ({ data }) => {
  if (!data || data.length === 0) {
    return <p className="chart-empty">No data available for graph.</p>;
  }

  // Ensure the graph reads sequentially left-to-right (e.g., Sprint 48 -> 49)
  const getSprintNum = (name) => {
    const match = name.match(/\d+/);
    return match ? parseInt(match[0], 10) : 0;
  };
  
  const sortedData = [...data].sort((a, b) => getSprintNum(a.name) - getSprintNum(b.name));

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="chart-tooltip">
          <p className="chart-tooltip-name" style={{ marginBottom: '8px' }}>{label}</p>
          {payload.map((entry, index) => (
            <p key={index} style={{ color: entry.color, margin: '2px 0', fontWeight: 600, fontSize: '0.85rem' }}>
              {entry.name}: {entry.value}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="chart-shell" style={{ height: '400px', padding: '20px 20px 0 0' }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={sortedData} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(158, 178, 197, 0.12)" vertical={false} />
          <XAxis 
            dataKey="name" 
            tick={{ fill: "var(--ink-soft)", fontSize: 11 }} 
            axisLine={false} 
            tickLine={false} 
            dy={10}
          />
          <YAxis 
            tick={{ fill: "var(--ink-soft)", fontSize: 11 }} 
            axisLine={false} 
            tickLine={false} 
          />
          <Tooltip cursor={{ stroke: 'rgba(159, 223, 255, 0.1)' }} content={<CustomTooltip />} />
          <Legend wrapperStyle={{ paddingTop: '10px', fontSize: '0.85rem', color: 'var(--ink-soft)' }} />
          
          <Line type="monotone" dataKey="total" name="Total Items" stroke="#eee48f" strokeWidth={3} activeDot={{ r: 6 }} />
          <Line type="monotone" dataKey="task" name="Tasks" stroke="#1ec8ee" strokeWidth={2} />
          <Line type="monotone" dataKey="story" name="Stories" stroke="#89f06f" strokeWidth={2} />
          <Line type="monotone" dataKey="bug" name="Bugs" stroke="#fc0000" strokeWidth={2} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SprintTrendGraph;